import React from 'react'
import {
  Box,
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
} from '@lightspeed/design-system-react'
import { T, useT } from '@transifex/react'
import { StepBreadcrumbs } from '../StepBreadcrumbs'
import { FulfillmentOutlet, STEPS } from '../types'
import { useVdFeatureManager } from '../../../../../../ng-compat/hooks'
import { FulfilmentType } from '../../../../../../models/fulfilment'
import { useCrossLocationFulfilmentGate } from '../../../../../sale/sale-line-item/fulfilment/OutletSelect/hooks/useCrossLocationFulfilmentGate'
import { OutletSelect } from '../../../../../sale/sale-line-item/fulfilment/OutletSelect/OutletSelect'
import { OutletToFulfilFrom } from './OutletToFulfilFrom'
import { FulfilmentSelect } from './FulfillmentSelect'

interface Props {
  onStepChange: (step: STEPS) => void
  onTypeChange: (type: FulfilmentType) => void
  onOutletChange: (outlet: string) => void
  type: FulfilmentType
  outlets: FulfillmentOutlet[]
  onClose: () => void
  currentOutlet: string
  totalQuantity: number
}

export const Step1Legacy: React.FC<Props> = ({
  onStepChange,
  onClose,
  type,
  outlets,
  onTypeChange,
  onOutletChange,
  currentOutlet,
  totalQuantity,
}) => {
  const vdFeatureManager = useVdFeatureManager()
  const shouldShowOutletPicker = vdFeatureManager.get(
    'fulfill_from_another_outlet'
  )

  const t = useT()
  const { canUseCrossLocationFulfilment } = useCrossLocationFulfilmentGate()

  return (
    <Modal size="small" onClose={onClose}>
      <StepBreadcrumbs step={STEPS.METHOD} />
      <ModalHeader>
        {t(
          '{totalQuantity, plural, one {Choose how the {totalQuantity} item in this sale will be fulfilled} other {Choose how all {totalQuantity} items in this sale will be fulfilled}}',
          { totalQuantity, _context: 'Mark as unfulfilled modal header' }
        )}

        <Text tag="p" className="vd-mt2">
          <T
            _str="Only one fulfilment method can be selected for items that require fulfillment. To record another method, create another sale."
            _context="Mark as unfulfilled modal header description"
          />
        </Text>
      </ModalHeader>
      <ModalContent>
        <>
          {canUseCrossLocationFulfilment && (
            <OutletSelect className="vd-mb5" showLabel />
          )}
          <FulfilmentSelect
            defaultType={type}
            name="fulfilType"
            onTypeChange={onTypeChange}
          />
          {shouldShowOutletPicker && (
            <OutletToFulfilFrom
              outlets={outlets}
              onOutletChange={onOutletChange}
              className="vd-mt5"
              currentOutlet={currentOutlet}
            />
          )}
        </>
      </ModalContent>
      <ModalActions>
        <Box className="vd-btn-group">
          <Button
            data-track="not-mark-as-unfufilled"
            onClick={() => onClose()}
            variant="supplementary"
          >
            {t('Don’t mark as unfulfilled', {
              _context: 'Mark as unfulfilled modal',
            })}
          </Button>
          <Button
            data-track="next-customer-step"
            onClick={() => onStepChange(STEPS.CUSTOMER)}
            variant="go"
          >
            {t('Next', {
              _context: 'Mark as unfulfilled modal - next button',
            })}
          </Button>
        </Box>
      </ModalActions>
    </Modal>
  )
}

Step1Legacy.displayName = 'Step1Legacy'
